import { useContext, useEffect } from "react";
import { getNormalizedIndex } from "../../utils/ArrayHelpers";
import { InputContext } from "./Input";
import { suffixId } from "./InputAutoCompleteDropdown";
const navigationDirection = { ArrowDown: 1, ArrowUp: -1 };
export function isAutoCompleteItem(item) {
    return item.value !== undefined;
}
export const useInputAutoComplete = (ref, { id, autoCompleteItems = [], onAutoCompleteSelect, value, type, onChange, onBlur, onKeyDown, show, hide, isVisible, }) => {
    if (autoCompleteItems === undefined || !show || !hide) {
        return {
            onChange,
            autoComplete: type === "password" ? "off" : undefined,
        };
    }
    const [focusedIndex, setFocusedIndex] = useContext(InputContext);
    const handleOnBlur = (e) => {
        var _a;
        // clicking in the auto-complete dropdown shouldn't unfocus the input
        if ((_a = document.getElementById(`${id}${suffixId}`)) === null || _a === void 0 ? void 0 : _a.contains(e.relatedTarget)) {
            e.preventDefault();
            return;
        }
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        hide(0);
    };
    const open = () => {
        setFocusedIndex(undefined);
        show(0);
    };
    const handleOnKeyDown = (e) => {
        if (!autoCompleteItems.length) {
            return;
        }
        if (isVisible && focusedIndex !== undefined && e.key === "Enter") {
            e.preventDefault();
            hide(0);
            setFocusedIndex(undefined);
            const item = autoCompleteItems[focusedIndex];
            const itemValue = isAutoCompleteItem(item) ? item.value : item;
            onChange(Object.assign(Object.assign({}, e), { target: Object.assign(Object.assign({}, e.target), { value: itemValue }), currentTarget: Object.assign(Object.assign({}, e.currentTarget), { value: itemValue }) }));
            onAutoCompleteSelect === null || onAutoCompleteSelect === void 0 ? void 0 : onAutoCompleteSelect(item);
        }
        else if (Object.keys(navigationDirection).includes(e.key)) {
            const key = e.key;
            e.preventDefault();
            if (isVisible) {
                // if nothing is focused, the ArrowDown should focus the first item
                const initialOffset = focusedIndex === undefined && key === "ArrowDown" ? -1 : 0;
                setFocusedIndex(getNormalizedIndex(autoCompleteItems, (focusedIndex || 0) + navigationDirection[key] + initialOffset));
            }
            else {
                open();
            }
        }
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    };
    // render new autocomplete items on menu
    useEffect(() => {
        if ((autoCompleteItems === null || autoCompleteItems === void 0 ? void 0 : autoCompleteItems.length) && document.activeElement === ref.current) {
            open();
        }
    }, [autoCompleteItems]);
    // hide menu when the value changes
    useEffect(() => {
        hide(0);
    }, [value]);
    return Object.assign(Object.assign({ autoComplete: "off", onBlur: handleOnBlur, onKeyDown: handleOnKeyDown }, (isVisible && Object.assign({ "aria-owns": `${id}${suffixId}` }, (focusedIndex !== undefined && {
        "aria-activedescendant": `${id}${suffixId}-${focusedIndex}`,
    })))), { "aria-autocomplete": "list" });
};
//# sourceMappingURL=useInputAutocomplete.js.map